import {CSSDimension, getPixelsFromRem} from 'platform/foundation';

const PIXELS_PER_STEP = getPixelsFromRem(1) ?? 0;

export const toDashboardAdaptiveCssHeight = (height: number): CSSDimension =>
  PIXELS_PER_STEP === 0 ? '0rem' : `calc(var(--eag-space-step) * ${height / PIXELS_PER_STEP}rem)`;
